import { unescape } from "lodash";

window.arjoWebinarCardModule =
  window.arjoWebinarCardModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };

    const classNamePrefix = 'arjo-o-webinar-card';

    const getLinkElement = (target) => {
      return target.querySelector(`.${classNamePrefix}__link`);
    };

    const cardClickHandler = (ev) => {
      const wistiaVideo = ev.currentTarget.querySelector(`.${classNamePrefix}__video`);
      if (wistiaVideo) {
        ev.preventDefault();

        const videoId = wistiaVideo.querySelector('.arjo-a-wistia-video').dataset.id;
        const wistiaApi = Wistia.api(videoId);

        if (wistiaApi) {
          wistiaApi.play();
        }
      } else {
        const link = getLinkElement(ev.currentTarget);

        if (link && ev.target !== link) {
          link.click();
        }

        const headerText = ev.target.dataset.headerText;

        if (headerText) {
          window.GA4.analyticsGa4.CTATracker.pushCTA('Clickable link', 'CTA block', unescape(headerText), 'arjo-o-webinar-card__link', '');
        }
      }
    };

    const onCardMouseDownHandler = (ev) => {
      if (ev.button === 1) {
        const link = getLinkElement(ev.currentTarget);

        if (link) {
          window.open(link?.href, '_blank')?.focus();
        }
      }
    };

    const init = () => {
      if (state.isInitialized) return;
      state.isInitialized = true;
    };
    return { init, cardClickHandler, onCardMouseDownHandler };
  })();

window.addEventListener('load', window.arjoWebinarCardModule.init);
